function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 45px;\n  width: 100%;\n  line-height: 1.5;\n  box-sizing: border-box;\n  color: ", ";\n\n  .MuiSelect-selectMenu {\n    box-sizing: border-box;\n    min-height: 35px;\n    height: 45px;\n  }\n\n  .MuiOutlinedInput-input {\n    padding: 6px 31px 6px 1rem;\n    line-height: 32px;\n  }\n\n  &.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n    border-color: ", ";\n  }\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defaultTheme } from '../../../utils';
import { StylesProvider, withStyles } from '@material-ui/styles';
import { applyStyleModifiers } from 'styled-components-modifiers';
var SELECT_MODIFIERS = {
  small: function small(_ref) {
    var theme = _ref.theme;
    return "\n    height: 35px;\n    .MuiOutlinedInput-input{\n      line-height: 24px;\n    }\n    .MuiSelect-selectMenu{\n      height: 35px;\n    }\n  ";
  },
  medium: function medium(_ref2) {
    var theme = _ref2.theme;
    return "\n    height: 45px;\n    .MuiOutlinedInput-input{\n      line-height: 32px;\n    }\n    .MuiSelect-selectMenu{\n      height: 45px;\n    }\n  ";
  },
  outlinedSuccess: function outlinedSuccess(_ref3) {
    var theme = _ref3.theme;
    return "\n    &.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n      border-color:  " + theme.status.successColorHover + ";  \n    }\n  ";
  },
  outlinedError: function outlinedError(_ref4) {
    var theme = _ref4.theme;
    return "\n    &.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n        border-color:  " + theme.status.errorColor + ";  \n    }\n  ";
  },
  hideBorder: function hideBorder() {
    return "\n  &.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n    border: none;  \n}";
  }
};
var StyledSelect = styled(Select)(_templateObject(), function (props) {
  return props.theme.textColor || defaultTheme.textColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.primaryColor;
}, applyStyleModifiers(SELECT_MODIFIERS));

var CustomSelect = function CustomSelect(_ref6) {
  var className = _ref6.className,
      items = _ref6.items,
      variant = _ref6.variant,
      defaultValue = _ref6.defaultValue,
      rest = _objectWithoutPropertiesLoose(_ref6, ["className", "items", "variant", "defaultValue"]);

  return /*#__PURE__*/React.createElement(StylesProvider, {
    injectFirst: true
  }, /*#__PURE__*/React.createElement(StyledSelect, _extends({
    className: "" + className,
    variant: variant,
    defaultValue: defaultValue || ''
  }, rest), items && items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: index,
      value: item.key ? item.key : ''
    }, item.value ? item.value : '');
  })));
};

CustomSelect.propTypes = process.env.NODE_ENV !== "production" ? {
  items: PropTypes.array.isRequired,
  variant: PropTypes.string
} : {};
CustomSelect.defaultProps = {
  variant: 'outlined',
  defaultValue: '',
  theme: defaultTheme
};
export default CustomSelect;